export default __webpack_public_path__ + "static/woocommerce_logo-480db964dfdcdd469a29046cc7bd9f73.svg";